module.exports = __webpack_public_path__ + "img/business-insider-uk.6046f7d4.png";